import ApplicationController from "controllers/application_controller"

export default class extends ApplicationController {
  connect() {
    this.emit("connected")
  }
}
